import React from 'react'
import MarketCard from './MarketCard'

const AllBackgroundImage = () => {
  const obj = require("../../BackgroundImage.json");
  return (
    <>
      {obj.map((value, i) => (
        <MarketCard key={i} value={value} variant="cover" category="background" />
      ))}
    </>
  )
}

export default AllBackgroundImage
